import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {VehicleType} from "../../../commons/types/vehicle.type";

export class LogisticsVehicleMultiSelectCtrl implements IController {

  selectedIds: any;
  ngPlaceholder: any;
  isDisabled: any;
  isStandAlone: boolean;
  vehicleTypes: VehicleType[];
  branchIds: string[];
  onChange: Function;

  private logisticsVehiclesRef: any;
  public selectedLogisticsVehicles: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $logisticsVehicle, private $element) {
    this.logisticsVehiclesRef = this.$logisticsVehicle();
  }

  $onInit() {
    this._setSelectedLogisticsVehicles();
  };

  $onChanges(changes) {
    if (changes.vehicleTypes && !changes.vehicleTypes.isFirstChange()){
      this._setSelectedLogisticsVehicles();
    }
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()){
      this._setSelectedLogisticsVehicles();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedIds || [];
    const ngPlaceholderRef = this.ngPlaceholder;
    const vehicleTypesRef = this.vehicleTypes;
    const branchIdsRef = this.branchIds;
    const isStandAloneRef = this.isStandAlone;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'logistic-vehicles';
        this.selectedIdsRef = selectedIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.queryMapRef = {
          isStandAlone: isStandAloneRef,
          vehicleTypes: vehicleTypesRef,
          branchIds: branchIdsRef
        }
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }

        this.logisticsVehiclesRef.$asyncValues(selectedIds)
          .then((logisticVehicles) => {
            this.onChange({logisticVehicles: logisticVehicles, ids: selectedIds});
            panel.destroy();
          });
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({ids: [], logisticsVehicles: []});
  }

  private _setSelectedLogisticsVehicles() {
    if (!!this.selectedIds) {
      this.logisticsVehiclesRef.$asyncValues(this.selectedIds)
        .then((logisticsVehicles) => {
          this.selectedLogisticsVehicles = _.orderBy(logisticsVehicles, ['name'], ['asc']);
          this._setSelectedText();
        });
    }else {
      this.selectedLogisticsVehicles = [];
      this._setSelectedText();
    }
  }

  private _setSelectedText() {
    let string = '';
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");

    _.forEach(this.selectedLogisticsVehicles, (b, i) => {
      string += b.name;
      if ((i + 1) < this.selectedLogisticsVehicles.length) {
        string += ', '
      }
    });

    var stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
      string = this.selectedLogisticsVehicles[0].name + ` +${this.selectedLogisticsVehicles.length - 1}`
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.logistics-vehicle')
  .component('logisticsVehicleMultiSelect', {
    bindings: {
      selectedIds: '<?',
      ngPlaceholder: '@?',
      isDisabled: '<?',
      isStandAlone: '<?',
      vehicleTypes: '<?',
      branchIds: '<?',
      onChange: '&'
    },
    template: require('./logistics-vehicle-multi-select.html').default,
    controller: LogisticsVehicleMultiSelectCtrl
  });
